import React from 'react';

import * as yup from 'yup';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';

import { Divider, Stack } from '@mui/material';

import AuthTemplate from './authTemplate';
import { useNavigate } from 'react-router-dom';
import PrimaryButton from '../ui/buttons/primaryButton';
import Input from '../ui/forms/fields/input';
import { useAlert } from '../../contexts/alertContext';
import userService from '../../features/user/userService';

const schema = yup.object().shape({
  email: yup.string().email('Invalid email').required('Email is required')
});

const ForgotPassword = () => {
  const [isSigningIn, setIsSigningIn] = React.useState(false);
  const { showAlertSuccess, showAlertError } = useAlert();
  const navigate = useNavigate();

  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(schema)
  });

  const onForgotPassword = async (data) => {
    if (!isSigningIn) {
      setIsSigningIn(true);
      try {
        await userService.requestPasswordReset(data.email);
        showAlertSuccess('If your email exists, a reset link has been sent.');
        navigate('/signin');
      } catch (err) {
        showAlertSuccess('If your email exists, a reset link has been sent.');
      }

      setIsSigningIn(false);
    }
  };

  return (
    <AuthTemplate
      title="Reset your password"
      subtitle="Enter your email and we will send a secure reset link if the account exists.">
      <Stack spacing={1.5}>
        <Input
          label="Email"
          variant="outlined"
          autoComplete="email"
          {...register('email')}
          error={!!errors.email}
          helperText={errors.email?.message}
        />
        <PrimaryButton
          fullWidth
          variant="contained"
          color="primary"
          size="large"
          disabled={isSigningIn}
          onClick={() => handleSubmit(onForgotPassword)()}>
          {isSigningIn ? 'Sending...' : 'Send Reset Link'}
        </PrimaryButton>
      </Stack>
      <Divider sx={{ m: 2 }} />
      <PrimaryButton fullWidth variant="outlined" color="info" onClick={() => navigate('/signin')}>
        Back to Sign In
      </PrimaryButton>
    </AuthTemplate>
  );
};

export default ForgotPassword;
